import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import { Breadcrumb, Button, Col, Row, Space, Tabs } from 'antd';
import SoftCourseList from './SoftCourseList';
import SoftBuy from './SoftBuy';
import { useGwGoodsUpdateQuery } from '../store/ReactWebSiteApi';
import SoftSpec from './SoftSpec';
import WebMain from './WebMain';

function SoftDesc() {
    const [param] = useSearchParams()
    const [info,setInfo] = useState({
        eowg_content:''
    }); 
    const {data,isSuccess} = useGwGoodsUpdateQuery({eowg_id:param.get('id')})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                              
                setInfo(prevState=>({...prevState,
                    eowg_name:data.Result.eowg_name,                  
                    eowg_dept_id:data.Result.eowg_dept_id,                  
                    eowg_content:data.Result.eowg_content,                  
                    eowg_dept_name:data.Result.eowg_dept_name,
                    eowg_image_file:data.Result.eowg_image_file,
                    eowg_luyou:data.Result.eowg_luyou,
                    eowg_state:data.Result.eowg_state,                  
                    eowg_goods:data.Result.eowg_goods,                  
                    eowg_bg_id:data.Result.eowg_bg_id,                  
                }))
            }
        }
    },[data,isSuccess])
    const items = [
        {
            label: '详情',
            key: 'intro',
            children: <div style={{fontSize:"14px",width:"800px"}} dangerouslySetInnerHTML={{__html:info.eowg_content}}></div>,
        },
        {
            label: '教程',
            key: 'organ',
            children: <SoftCourseList bjc_eowg_id={param.get('id')}/>,
        },
        {
            label: '购买',
            key: 'id',
            children: <SoftBuy bsg_bg_id={info.eowg_bg_id} bsg_eowg_id={param.get('id')}/>,
        },
     ]
    return (
        <WebMain selectedKeys=''>            
            <Row>
                <Col span={5}></Col>
                <Col span={10}>
                    <Breadcrumb style={{margin:"20px 0"}}>
                        <Breadcrumb.Item>
                            <a href="/">全部产品</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <a >{info.eowg_name}</a>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div
                        style={{
                            fontSize:"24px",
                            display:'flex',
                            alignItems:"center",
                            width:"100%",
                        }}
                    >
                        <img 
                            src={`/api/assets/images/application/${info.eowg_image_file}`} 
                            alt='' 
                            width={224}
                            style={{
                                border:"2px solid #eee"
                            }}
                        />
                        <Space direction='vertical' style={{marginLeft:"60px"}} size={20}>
                            {info.eowg_name}
                            <SoftSpec
                                eowgg_eowg_id={param.get('id')}
                            />
                            <Button
                                type='primary'
                                size='large'
                                onClick={() => {
                                    window.open(info.eowg_luyou)
                                }}
                            >免费试用</Button>
                        </Space>
                    </div> 
                    <div style={{padding:"20px"}}>
                        <Tabs
                            items={items}
                            size='large'
                            type='card'
                        />
                    </div>
                </Col>
                <Col span={7}>
                     
                </Col>
            </Row>   
        </WebMain>
    )
}

export default SoftDesc